import { supabase } from '../lib/supabase';

// Test function to debug password reset
export const testPasswordReset = async (email) => {
  try {
    console.log('Testing password reset for email:', email);
    console.log('Redirect URL will be:', `${window.location.origin}/reset-password`);
    
    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`
    });
    
    console.log('Reset password result:', { data, error });
    
    if (error) {
      console.error('Reset password error details:', error);
      return { success: false, error };
    }
    
    return { success: true, data };
  } catch (err) {
    console.error('Reset password exception:', err);
    return { success: false, error: err };
  }
};

// Function to manually check auth state
export const checkAuthState = async () => {
  try {
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    
    console.log('Current session:', session);
    console.log('Current user:', user);
    console.log('Session error:', sessionError);
    console.log('User error:', userError);
    
    return { session, user, sessionError, userError };
  } catch (err) {
    console.error('Error checking auth state:', err);
    return { error: err };
  }
};

// Function to handle auth URL parameters manually
export const handleAuthCallback = async () => {
  try {
    const urlParams = new URLSearchParams(window.location.hash.substring(1));
    const accessToken = urlParams.get('access_token');
    const refreshToken = urlParams.get('refresh_token');
    const type = urlParams.get('type');
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');
    
    console.log('URL parameters:', {
      accessToken: accessToken ? '***EXISTS***' : null,
      refreshToken: refreshToken ? '***EXISTS***' : null,
      type,
      error,
      errorDescription
    });
    
    if (error) {
      console.error('Auth callback error:', error, errorDescription);
      return { success: false, error, errorDescription };
    }
    
    if (accessToken && refreshToken && type === 'recovery') {
      console.log('Setting session with tokens...');
      const { data, error: setError } = await supabase.auth.setSession({
        access_token: accessToken,
        refresh_token: refreshToken
      });
      
      console.log('Set session result:', { data, error: setError });
      
      if (setError) {
        return { success: false, error: setError };
      }
      
      return { success: true, data };
    }
    
    return { success: false, error: 'No valid tokens found' };
  } catch (err) {
    console.error('Error handling auth callback:', err);
    return { success: false, error: err };
  }
};
